module.exports = __webpack_public_path__ + "static/media/Danger.9c75699b.svg";